import React from 'react';
import { Button, ModalCardBase, PopoutWrapper } from '@vkontakte/vkui';
import { Icon28LockOutline, Icon28StarsOutline } from '@vkontakte/icons';
import { achievementLockedDescription } from '../../utils/text';

export function AchievementModal({ achievement, onClose }) {
  if (!achievement) {
    return null;
  }

  return (
    <PopoutWrapper fixed alignY="center" alignX="center" onClick={onClose}>
      <ModalCardBase
        icon={achievement.is_opened ? <Icon28StarsOutline width={56} height={56} /> : <Icon28LockOutline width={56} height={56} />}
        header={achievement.name || 'Достижение'}
        subheader={achievement.is_opened ? achievement.description : achievementLockedDescription(achievement)}
        onClose={onClose}
        actions={<Button size="l" mode="primary" stretched onClick={onClose}>Закрыть</Button>}
        onClick={(event) => event.stopPropagation()}
      />
    </PopoutWrapper>
  );
}
